export default {
  iconAltText: {
    id: 'header_cart_icon_alt_text',
    defaultMessage: 'Cart',
  },
}
